import http from "./httpService";
import { apiUrl } from "../config";


function register(user, captchaResponse) {
  return http.post(apiUrl + "/public-api/users/create", {
    Email: user.email,
    Password: user.password,
    Name: user.name,
    Captcha: captchaResponse,
    InvoiceName: user.invoice_name,
    InvoiceZip: user.invoice_zip,
    InvoiceAddress: user.invoice_address,
    InvoiceTaxCode: user.invoice_taxcode,
    InvoiceEmail: user.invoice_email,
    InvoiceCity: user.invoice_city
  });
}

function update(user) {
  let data = {
    Email: user.email,
    Name: user.name,
    InvoiceName: user.invoice_name,
    InvoiceZip: user.invoice_zip,
    InvoiceAddress: user.invoice_address,
    InvoiceTaxCode: user.invoice_taxcode,
    InvoiceEmail: user.invoice_email,
    InvoiceCity: user.invoice_city,
    CurrentPassword: user.current_password,
    ChangePassword: user.change_password,
  }
  
  if(user.change_password) {
    data['Password'] = user.password;
  }

  return http.post(apiUrl + "/api/me/update", data);
}

function getUserProfile() {
  return http.get(apiUrl + "/api/me");
}

function deleteUserProfile() {
  return http.post(apiUrl + "/api/me/delete");
}

export default {
  register: register,
  update: update,
  getUserProfile: getUserProfile,
  deleteUserProfile: deleteUserProfile,
};
